<script lang="ts">
      import { onMount, tick } from 'svelte'
      import Button from '../ui/Button.svelte'
      import { getScrollBlockContext } from '$lib/ui/menu/index.svelte'
      import { getAnalyticsContext } from './ts/Anatytics.svelte'
      import Toggle from '../ui/Toggle.svelte'
      import CookiebarDetail from './CookiebarDetail.svelte'
      import { getLocaleContext } from '../locale/ts/Locale.svelte'
      import { CookieText } from './ts/CookieText'
      import LocaleSwitcher from '../locale/LocaleSwitcher.svelte'

      async function allConsentGranted() {
        analytics.setConsent({necessary: true, analytics: true, marketing: true})
        
      }
      
      async function necessaryConsentGranted() {
        analytics.setConsent({necessary: true, analytics: false, marketing: false})

      }

      async function onConsentSubmit(consent: any) {
            analytics.setConsent(consent)
            detail.close()
      }

      async function flipBar() {
            if (!bar) return

            _lastVisible = visible

            bar.getAnimations().map((a) => a.pause())

            const start_opacity = getComputedStyle(bar).opacity
            const start_display = getComputedStyle(bar).display

            bar.getAnimations().map((a) => a.cancel())

            if (!visible) bar.classList.remove('open')
            else if (visible) bar.classList.add('open')

            await tick()

            const end_opacity = getComputedStyle(bar).opacity
            const end_display = getComputedStyle(bar).display

            bar.animate(
                  [
                        { opacity: start_opacity, display: start_display },
                        { opacity: end_opacity, display: end_display },
                  ],
                  {
                        duration: 400,
                        fill: 'backwards',
                  }
            )
      }

      $effect(() => {
            if (_lastVisible != visible) {
                  flipBar()
                  if (visible) scrollBlock.requestBodyScrollBlock(bar)
                  else scrollBlock.releaseBodyScrollBlock(bar)
            }
      })

      onMount(() => {})

      const scrollBlock = getScrollBlockContext()
      const analytics = getAnalyticsContext()
      const locale = getLocaleContext()

      let visible = $derived(analytics.consentRequired)
      let _lastVisible = false

      let bar: HTMLDivElement

      let detail: CookiebarDetail
</script>

<div bind:this={bar} class="cookiebar fixed top-0 w-full h-dvh bg-[#FFFFFF66] z-[100] flex items-center justify-center">
      <div class="cookie mx-auto bg-[#ffffff] rounded-t-xl md:rounded-xl h-[92dvh] md:h-[32rem] w-full md:w-1/4 md:min-w-96 mt-auto md:absolute relative">
            <div class="w-full h-full flex flex-col gap-4 overflow-y-auto">
                  <div class="font-primary p-6 flex flex-col gap-3 h-full">
                        <div class="ml-auto border-[1px] border-black rounded-full px-2">
                              <LocaleSwitcher></LocaleSwitcher>
                        </div>
                        <h1 class="text-xl mb-6 mt-6 text-center font-accent flex items-center justify-center">🍪 Cookies 🍪</h1>
                        <div class="w-full">
                              <p>
                                    {locale.ŧ(CookieText.main)}
                              </p>
                        </div>
                        <div class="w-full flex flex-col gap-3 mt-auto">
                              <Button size="normal" onclick={(ev) => allConsentGranted()} type="button"><div class="w-full text-center">{locale.ŧ(CookieText.acceptAll)}</div></Button>
                              <Button size="normal" onclick={(ev) => necessaryConsentGranted()} variant="secondary" type="button"><div class="w-full text-center">{locale.ŧ(CookieText.acceptRequired)}</div></Button>
                              <Button size="normal" onclick={async() => detail.open()} type="button" variant="secondary"><div class="w-full text-center">{locale.ŧ(CookieText.customize)}</div></Button>
                        </div>
                  </div>
            </div>
            <CookiebarDetail bind:this={detail} onsubmit={onConsentSubmit}></CookiebarDetail>
      </div>
</div>

<style lang="postcss">
      @reference "tailwindcss/theme";

      .cookiebar {
            @apply opacity-0;
            display: none;
      }

      .cookiebar:global(.open) {
            @apply flex opacity-100;
      }

      .cookie {
            @apply h-auto;
            box-shadow: 0 2px 15px 7px #39393971;
            transition: all 0.3s ease-in-out;
      }

      .cookie:global(:has(.detail.open)) {
            @apply h-max;
      }
</style>
